import { Product } from "@dashboard/types/product";
import type { ReduxState } from "@dashboard/types/reduxState";

import { RestaurantChangedAction } from "./restaurantReducer";

export type ProductReducerAction =
  | RestaurantChangedAction
  | { type: "FETCHED_PRODUCTS"; payload: Product[] };

export const productReducer: (
  state: ReduxState["product"] | undefined,
  action: ProductReducerAction
) => ReduxState["product"] = (
  state: ReduxState["product"] = {
    initialProductsLoading: true,
    products: [],
  },
  action: ProductReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_CHANGED":
      return {
        ...state,
        initialProductsLoading: true,
      };
    case "FETCHED_PRODUCTS":
      return {
        ...state,
        initialProductsLoading: false,
        products: action.payload,
      };
    default:
      return state;
  }
};
